module.exports = __webpack_public_path__ + "img/app_code.b839045a.png";